import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AdjustPartialRelease, CommissionAdjustment, CommissionAvalible } from 'src/app/model/other-catalogs-models';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';

@Component({
  selector: 'app-modal-commission-partial',
  templateUrl: './modal-commission-partial.component.html',
  styleUrls: ['./modal-commission-partial.component.css']
})
export class ModalCommissionPartialComponent implements OnInit {

  IdAsesor:string = '';
  NombreAsesor:string = null; 
  nota:string= '' ;
  CommissionAdjustmentAmount:string = null;
  CommissionAdjustmentAvalible:string =  null;
  ajusteComision:number;
  listAdjustPartialRelease : AdjustPartialRelease[] =[];
  listCommissionAdjustment: CommissionAdjustment [] = [];
  listToFree: number[]=[];
   commissionAvalible : CommissionAvalible;
  CommissionToFree:number = null;
  

  constructor(private commissionSalePromotionsService:CommissionSalePromotionsService,
    private toastr:ToastrService,
    private modalService: NgbModal) { }
    public comentarioAjuste: string='';
    public ajuste : boolean =false;
    public userId =Number(localStorage.getItem('com_token')) 

    dtOptions={
      order:[],
      responsive:true,
      columnDefs: [
        // { responsivePriority: 1, width:100, targets: -1 }
      ],
      bLengthChange: true,
      searching :true,
      dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: ['csv', 'excel'],
      autoWidth:false,
      // pagingType: 'full_numbers',
      paging:true,
      pageLength: 5,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        },
        // dom: 'Bfrtip',
        buttons: [
          'excel'
        ]
      }
    };

  ngOnInit() {

    this.getAdjustments();
  }

  close=()=> {

    this.modalService.dismissAll();
  }


  GetBPartner=(idEmpleado: string)=> {
    this.commissionAvalible= null
    this.CommissionToFree = null
    this.listToFree.splice(0);
    forkJoin(
      this.commissionSalePromotionsService.getAdjustmentsPartialCommission(idEmpleado),
      this.commissionSalePromotionsService.GetAdjustmentAvalible(idEmpleado)
    )
      .pipe(
        tap(([credResp, avalResp]:[any, any])=> {

        this.listAdjustPartialRelease = credResp.data; 
        
        this.NombreAsesor = this.listAdjustPartialRelease[0].EmployeeName; 

        this.commissionAvalible = avalResp.data;

        this.CommissionAdjustmentAmount = this.commissionAvalible[0].CommissionAdjustmentAmount
        this.CommissionAdjustmentAvalible = this.commissionAvalible[0].CommissionAdjustmentAvalible


        console.log (this.commissionAvalible)
        //this.modalService.dismissAll();
        //this.toastr.success("Las comisiones se han guardado con éxito.")
        
        }),
        catchError(error=> {
          console.log(error)
          
          return of(this.toastr.error('Ocurrió un error al leer las retenciones'));
        })
      )
      .subscribe();
  }


  getAdjustments=()=> {
    this.listCommissionAdjustment =[];
    this.commissionSalePromotionsService.getAdjustments()
    
      .pipe(
        tap((resp:any)=> {

        this.listCommissionAdjustment = resp.data; 
        console.log (this.listCommissionAdjustment)

        }),
        catchError(error=> {
          
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
        })
      )
      .subscribe();
  }

  ChangePartialAdjustment=(iCreditId: string, value:number)=> {
    this.commissionSalePromotionsService.partialAdjustmentSet(iCreditId, value)
      .pipe(
        tap((resp:any)=> {
         if(resp.codeHttpStatus===200) {
          this.toastr.success('En la próxima simulación aparecerá tu liberación')
          this.CommissionToFree = this.CommissionToFree - value;
         }
        //this.listCommissionAdjustment = resp.data; 
        //console.log (listComisionDispositionResume)

        }),
        catchError(error=> {
          
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de regiones.'));
        })
      )
      .subscribe();
  }
}
